__webpack_require__.p = "https://dashboard-beta.delfi.se/";